// import React, { useState, useEffect } from "react";
// import { useHistory, useLocation } from "react-router-dom";

// import CircularProgress from "@mui/material/CircularProgress";

// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";

// import callAPI from "~src/utils/callAPI";

// export default function AutocompleteInput(props) {
//   const {
//     placeholder,
//     filtername,
//     type,
//     provider,
//     setProvider,
//     providerLabel,
//     providerList,
//   } = props;

//   const history = useHistory();
//   const location = useLocation();
//   const { pathname } = location;
//   const searchParams = new URLSearchParams(location.search);

//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterValue, setFilterValue] = useState(() => {
//     const paramValue = searchParams.get(filtername);
//     return paramValue ? { name: paramValue } : { name: "" };
//   });

//   const [options, setOptions] = useState([]);
//   const loading = isOpen && options.length === 0;

//   const handleInput = (event, value, reason) => {
//     if (reason === "input") {
//       setSearchTerm(value);
//       let filterAPI = filtername;
//       if (filtername.split("-").length === 1) {
//         filterAPI = `provider-${filtername}`;
//       }
//       if (type === undefined) {
//         if (value.length === 0) {
//           searchParams.delete(filterAPI);
//           history.push({
//             pathname,
//             search: searchParams.toString(),
//           });
//           setFilterValue({ name: "" });
//         }
//       } else {
//         if (value.length === 0) {
//           setSearchTerm("");

//           const currentProvider = { ...provider };
//           currentProvider[filterAPI] = [];

//           const providerListCopy = { ...providerList };
//           providerListCopy[providerLabel] = currentProvider;

//           setProvider(() => ({
//             ...providerListCopy,
//           }));

//           searchParams.delete(filterAPI);
//           history.push({
//             pathname,
//             search: searchParams.toString(),
//           });
//           setFilterValue({ name: "" });
//         }
//       }
//     }
//   };

//   const handleChange = (event, value, reason) => {
//     if (reason === "selectOption") {
//       setIsOpen(false);
//       setOptions([]);
//       setSearchTerm("");
//       setFilterValue({ name: value.name });
//       let filterAPI = filtername;
//       if (filtername.split("-").length === 1) {
//         filterAPI = `provider-${filtername}`;
//       }
//       if (type === undefined) {
//         searchParams.set(`${filterAPI}`, value.name);
//         history.push({
//           pathname,
//           search: searchParams.toString(),
//         });
//       } else {
//         const currentProvider = { ...provider };

//         // console.log("curr",currentProvider);
//         currentProvider[filterAPI] = [value.name];

//         const providerListCopy = { ...providerList };
//         providerListCopy[providerLabel] = currentProvider;

//         setProvider(() => ({
//           ...providerListCopy,
//         }));
//       }
//     }
//   };

//   useEffect(() => {
//     if (isOpen) {
//       searchParams.delete(filtername);
//       let queryString = "";

//       let filterAPI = filtername;
//       if (filtername.split("-").length === 1) {
//         filterAPI = `provider-${filtername}`;
//       }

//       const providerDetails = {};
//       providerDetails["provider-group"] = provider["provider-group"];
//       providerDetails["provider-type"] = provider["provider-type"];
//       providerDetails["provider-name"] = provider["provider-name"];
//       providerDetails["clinician-speciality"] =
//         provider["clinician-speciality"];

//       const existingParams = new URLSearchParams(providerDetails).toString();
//       queryString = `${existingParams}&q=${searchTerm}&filter_name=${filterAPI}`;

//       if (
//         filtername === "clinician-name" ||
//         filtername === "clinician-speciality"
//       ) {
//         const providerDetails = {};
//         providerDetails["provider-group"] = provider["provider-group"];
//         providerDetails["provider-type"] = provider["provider-type"];
//         providerDetails["provider-name"] = provider["provider-name"];
//         providerDetails["clinician-speciality"] =
//           provider["clinician-speciality"];

//         callAPI("GET", `get_filters/?${queryString}`, "").then((res) => {
//           let providerField = [];
//           if (res && Array.isArray(res)) {
//             if (filtername === "clinician-name") {
//               providerField = res?.map((value) => ({
//                 name: value.clinician__name,
//               }));
//             } else {
//               providerField = res?.map((value) => ({
//                 name: value.clinician__category,
//               }));
//             }
//             setOptions([...providerField]);
//           } else {
//             setOptions(["undefined"]);
//           }
//         });
//       } else {
//         callAPI("GET", `get_filters/provider?${queryString}`, "").then(
//           (res) => {
//             let providerField = [];
//             if (filtername === "group" || filtername === "provider-group") {
//               providerField =
//                 res && Array.isArray(res)
//                   ? res.map((value) => ({
//                       name: value.prov_group,
//                     }))
//                   : [];
//             } else if (
//               filtername === "group" ||
//               filtername === "provider-group" ||
//               filtername === "name" ||
//               filtername === "provider-name"
//             ) {
//               providerField = res.map((value) => ({
//                 name: value.name,
//               }));
//             } else if (
//               filtername === "type" ||
//               filtername === "provider-type"
//             ) {
//               providerField = res.map((value) => ({
//                 name: value.facility_type,
//               }));
//             }

//             setOptions([...providerField]);
//           }
//         );
//       }
//     }
//   }, [searchTerm, isOpen]);

//   useEffect(() => {
//     if (!isOpen) {
//       setOptions([]);
//     }
//   }, [isOpen]);

//   useEffect(() => {
//     // set filter value if we pass global filter in browser search bar directly
//     setFilterValue(() => {
//       const paramValue = searchParams.get(filtername);
//       return paramValue ? { name: paramValue } : { name: "" };
//     });
//   }, []);

//   return (
//     <>
//       <div className="w-100">
//         <Autocomplete
//           open={isOpen}
//           openOnFocus
//           onClose={() => {
//             setIsOpen(false);
//           }}
//           onOpen={() => {
//             setIsOpen(true);
//           }}
//           autoComplete
//           value={filterValue}
//           className="w-100 px-2"
//           filterOptions={(x) => x}
//           noOptionsText="loading..."
//           isOptionEqualToValue={(option, value) => option.name === value.name}
//           onClick={() => setIsOpen(true)}
//           getOptionLabel={(option) => option.name}
//           onInputChange={handleInput}
//           onChange={handleChange}
//           options={options}
//           renderOption={(props, option) => (
//             <li
//               {...props}
//               key={`${option.name}`}
//               className="option-row d-flex justify-content-between px-3 py-2 border-bottom"
//             >
//               {option.name}
//             </li>
//           )}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               variant="standard"
//               placeholder={placeholder}
//               InputProps={{
//                 ...params.InputProps,
//                 style: { fontSize: "12px", padding: "0" },
//                 disableUnderline: false,
//                 endAdornment: (
//                   <div>
//                     {loading ? (
//                       <CircularProgress color="inherit" size={20} />
//                     ) : null}
//                   </div>
//                 ),
//               }}
//             />
//           )}
//         />
//       </div>
//       <span>/ </span>
//     </>
//   );
// }






















// code for linking dash and increased width for filters
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import callAPI from "~src/utils/callAPI";
import Popper from "@mui/material/Popper";
export default function AutocompleteInput(props) {
  const {
    placeholder,
    filtername,
    type,
    provider,
    setProvider,
    providerLabel,
    providerList,
  } = props;

  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const searchParams = new URLSearchParams(location.search);

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterValue, setFilterValue] = useState(() => {
    const providerValue = provider[filtername]?.[0];
    const paramValue = searchParams.get(filtername);
    return providerValue ? { name: providerValue } : paramValue ? { name: paramValue } : { name: "" };
  });
  const [options, setOptions] = useState([]);
  const loading = isOpen && options.length === 0;

  // Sync filterValue with provider[filtername] or searchParams
  useEffect(() => {
    const providerValue = provider[filtername]?.[0];
    const paramValue = searchParams.get(filtername);
    if (providerValue && filterValue.name !== providerValue) {
      setFilterValue({ name: providerValue });
    } else if (paramValue && filterValue.name !== paramValue && !providerValue) {
      setFilterValue({ name: paramValue });
    }
  }, [provider, filtername, searchParams]);

  // Fetch options on mount if provider[filtername] or searchParams is set
  useEffect(() => {
    const providerValue = provider[filtername]?.[0];
    const paramValue = searchParams.get(filtername);
    if ((providerValue || paramValue) && options.length === 0) {
      fetchOptions(providerValue || paramValue || "");
    }
  }, [provider, filtername, searchParams]);

  const fetchOptions = (query = "") => {
    let filterAPI = filtername;
    if (filtername.split("-").length === 1) {
      filterAPI = `provider-${filtername}`;
    }

    const providerDetails = {
      "provider-group": provider["provider-group"],
      "provider-type": provider["provider-type"],
      "provider-name": provider["provider-name"],
      "clinician-speciality": provider["clinician-speciality"],
    };

    const existingParams = new URLSearchParams(providerDetails).toString();
    const queryString = `${existingParams}&q=${query}&filter_name=${filterAPI}`;

    if (filtername === "clinician-name" || filtername === "clinician-speciality") {
      callAPI("GET", `get_filters/?${queryString}`, "").then((res) => {
        let providerField = [];
        if (Array.isArray(res)) {
          if (filtername === "clinician-name") {
            providerField = res.map((value) => ({ name: value.clinician__name }));
          } else {
            providerField = res.map((value) => ({ name: value.clinician__category }));
          }
        } else {
          console.error(`API response for ${filtername} is not an array:`, res);
        }
        const providerValue = provider[filtername]?.[0] || query;
        if (providerValue && !providerField.some((opt) => opt.name === providerValue)) {
          providerField.push({ name: providerValue });
        }
        setOptions([...providerField]);
      }).catch((error) => {
        console.error(`Error fetching ${filtername} options:`, error);
        const providerValue = provider[filtername]?.[0] || query;
        setOptions(providerValue ? [{ name: providerValue }] : []);
      });
    } else {
      callAPI("GET", `get_filters/provider?${queryString}`, "").then((res) => {
        let providerField = [];
        if (Array.isArray(res)) {
          if (filtername === "group" || filtername === "provider-group") {
            providerField = res.map((value) => ({ name: value.prov_group })) || [];
          } else if (filtername === "name" || filtername === "provider-name") {
            providerField = res.map((value) => ({ name: value.name })) || [];
          } else if (filtername === "type" || filtername === "provider-type") {
            providerField = res.map((value) => ({ name: value.facility_type })) || [];
          }
        } else {
          console.error(`API response for ${filtername} is not an array:`, res);
        }
        const providerValue = provider[filtername]?.[0] || query;
        if (providerValue && !providerField.some((opt) => opt.name === providerValue)) {
          providerField.push({ name: providerValue });
        }
        setOptions([...providerField]);
      }).catch((error) => {
        console.error(`Error fetching ${filtername} options:`, error);
        const providerValue = provider[filtername]?.[0] || query;
        setOptions(providerValue ? [{ name: providerValue }] : []);
      });
    }
  };

  const handleInput = (event, value, reason) => {
    if (reason === "input") {
      setSearchTerm(value);
      let filterAPI = filtername;
      if (filtername.split("-").length === 1) {
        filterAPI = `provider-${filtername}`;
      }
      if (value.length === 0) {
        setFilterValue({ name: "" });
        const currentProvider = { ...provider };
        currentProvider[filterAPI] = [];
        const providerListCopy = { ...providerList };
        providerListCopy[providerLabel] = currentProvider;
        setProvider({ ...providerListCopy });
        searchParams.delete(filterAPI);
        history.push({ pathname, search: searchParams.toString() });
      }
    }
  };

  const handleChange = (event, value, reason) => {
    if (reason === "selectOption") {
      setIsOpen(false);
      setOptions([]);
      setSearchTerm("");
      setFilterValue({ name: value.name });
      let filterAPI = filtername;
      if (filtername.split("-").length === 1) {
        filterAPI = `provider-${filtername}`;
      }
      const currentProvider = { ...provider };
      currentProvider[filterAPI] = [value.name];
      const providerListCopy = { ...providerList };
      providerListCopy[providerLabel] = currentProvider;
      setProvider({ ...providerListCopy });
      searchParams.set(filterAPI, value.name);
      history.push({ pathname, search: searchParams.toString() });
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchOptions(searchTerm);
    } else {
      setOptions([]);
    }
  }, [searchTerm, isOpen]);

  return (
    <div className="w-100" style={{ position: "relative" }}>
    <Autocomplete
      open={isOpen}
      openOnFocus
      onClose={() => setIsOpen(false)}
      onOpen={() => setIsOpen(true)}
      autoComplete
      value={filterValue}
      className="w-100 px-2"
      filterOptions={(x) => x}
      noOptionsText="loading..."
      isOptionEqualToValue={(option, value) => option.name === value.name}
      onClick={() => setIsOpen(true)}
      getOptionLabel={(option) => option.name || ""}
      onInputChange={handleInput}
      onChange={handleChange}
      options={options}
      PopperComponent={(popperProps) => (
        <Popper
          {...popperProps}
          style={{
            ...popperProps.style,
            minWidth: "200px", // Increased minimum width for the dropdown
            maxWidth: "90vw", // Prevent overflow on small screens
          }}
          placement="bottom-start"
        />
      )}
      renderOption={(props, option) => (
        <li
          {...props}
          key={`${option.name}`}
          className="option-row d-flex justify-content-between px-3 py-2 border-bottom"
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {option.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          placeholder={placeholder}
          aria-label={`Filter by ${placeholder}`}
          InputProps={{
            ...params.InputProps,
            style: { fontSize: "12px", padding: "0" },
            disableUnderline: false,
            endAdornment: (
              <div>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
              </div>
            ),
          }}
        />
      )}
      sx={{
        "& .MuiAutocomplete-popper": {
          minWidth: "300px", // Increased minimum width for consistency
          maxWidth: "90vw", // Limit to 90% of viewport width
          width: "auto !important", // Allow dynamic sizing based on content
        },
        "& .MuiAutocomplete-listbox": {
          maxHeight: "50vh",
          overflowY: "auto",
          padding: 0,
        },
        "& .MuiAutocomplete-option": {
          whiteSpace: "normal",
          wordBreak: "break-word",
          padding: "8px 16px",
        },
      }}
    />
    <span>/ </span>
  </div>
  );
}